'use strict';

var _ = require('lodash');
var SponsorLegTransformerFactory = function SponsorLegTransformerFactory(DataTransformer, momentService) {
  function SponsorLegTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'sponsor-forecast-leg';
    this.priority = 1;
  }
  SponsorLegTransformer.prototype = Object.create(DataTransformer.prototype);
  SponsorLegTransformer.constructor = SponsorLegTransformer;
  SponsorLegTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SponsorLegTransformer.prototype.isCacheable = function () {
    return true;
  };
  SponsorLegTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SponsorLegTransformer.prototype.transform = function (data) {
    if (data.domain.flattenedAggregatedConfiguredLegs === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    return _.transform(data.domain.flattenedAggregatedConfiguredLegs, function (result, entry) {
      return result.push({
        departureDate: memoizedMomentOfDate(entry.legDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        resHoldTotal: entry.resHoldTotal,
        currentRevenue: entry.currentRevenue,
        currentLoadFactor: entry.currentLoadFactor,
        physicalCapacity: entry.physicalCapacity,
        flight: entry.carrier + entry.number
      });
    });
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return SponsorLegTransformer;
};
SponsorLegTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = SponsorLegTransformerFactory;